class FavIcon
{
    constructor()
    {
        this.open = false
        this.iconLink = document.createElement("link")
        this.iconLink.setAttribute("rel", "icon")
        this.appleIconLink = document.createElement("link")
        this.appleIconLink.setAttribute("rel", "apple-touch-icon")
        const head = document.getElementsByTagName("head")[0]
        head.appendChild(this.iconLink)
        head.appendChild(this.appleIconLink)
        this.write()
    }

    setOpen(open)
    {
        this.open = open
        this.write()
    }

    write()
    {
        this.iconLink.setAttribute("href", this.open ? 'icon-open.svg' : 'icon-closed.svg')
        this.appleIconLink.setAttribute("href", this.open ? 'icon-open192.png' : 'icon-closed192.png')
    }
}

export default new FavIcon
